import OBase from './OBase';

import * as Geometry from '../geometry';

export default class InteractiveLength extends OBase {
  constructor (src) {
    super(src);

    this.handlePosRatio = 0.5;
  }

  update () {
    let staInput = this.getVector3Input('start');
    let diInput = this.getVector3Input('direction');
    let miInput = this.getFloatInput('min');
    let maInput = this.getFloatInput('max');
    let deInput = this.getFloatInput('decimal');
    let steInput = this.getFloatInput('steps');
    let alInput = this.getFloatInput('align');

    let lOutput = this.outputs['length'].paramObject;
    let pOutput = this.outputs['points'].paramObject;

    let start = staInput.branches[0][0];
    let dir = diInput.branches[0][0];
    dir.normalize();
    let min = miInput.branches[0][0];
    let max = maInput.branches[0][0];
    let deci = deInput.branches[0][0];
    let step = Math.max(steInput.branches[0][0], 1);
    let align = alInput.branches[0][0];
    this.length = min + (max - min) * this.handlePosRatio;
    // console.log(this.max)
    this.startPos = new THREE.Vector3();
    this.endPos = new THREE.Vector3();
    this.max = max;
    this.min = min;

    var lOutTree = new Geometry.DataTree();
    var pOutTree = new Geometry.DataTree();

    this.startPos = new THREE.Vector3(start.x, start.y, start.z);
    let maxDist = max;
    let minDist = min;
    if (align === 1) {
      dir.multiplyScalar(-1);
    } else if (align === 2) {
      maxDist = max * 0.5;
    }

    let maxPos = start.clone();
    let maxDir = dir.clone();
    maxDir.multiplyScalar(maxDist);
    maxPos.add(maxDir);

    this.maxPos = new THREE.Vector3(maxPos.x, maxPos.y, maxPos.z);

    let minPos = start.clone();
    let minDir = dir.clone();
    minDir.multiplyScalar(minDist);
    minPos.add(minDir);
    this.minPos = new THREE.Vector3(minPos.x, minPos.y, minPos.z);

    lOutTree.add(this.length, new Geometry.GHPath(0));

    let endPos = new THREE.Vector3();
    for (let i = 0; i < step + 1; i++) {
      let pos = start.clone();

      if (align === 2) {
        let dirb = dir.clone();
        dirb.multiplyScalar(-this.length * 0.5);
        pos.add(dirb);
      }

      let addv = dir.clone();
      addv.normalize();
      addv.multiplyScalar(i * this.length / step);
      pos.add(addv);
      pOutTree.add(pos, new Geometry.GHPath(0));
      if (i === step) {
        endPos = pos;
      }
    }

    lOutput.value = lOutTree;
    pOutput.value = pOutTree;

    this.endPos = new THREE.Vector3(endPos.x, endPos.y, endPos.z);
    this.handlePos = this.endPos.clone();
  }

  updateHandlePosRatio (ratio, fromZero = false) {
    // let minratio = this.min / this.max
    // ratio = Math.min(Math.max(minratio, ratio), 1.0)
    if (fromZero === true) {
      // console.log(ratio)
      ratio = (ratio * this.max - this.min) / (this.max - this.min);
      // console.log(ratio)
    }

    this.handlePosRatio = ratio;
    this.update();
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/InteractiveLength.js